<div class="technical" [style.--background-image]="'url(' + image + ')'">
  <div class="technical__content">
    <img *ngIf="icon" src="{{ icon }}" alt="" loading="lazy">
    <h3 class="header">{{ header }}</h3>
    <p *ngIf="description" class="description">
      {{ description }}
    </p>
    <p *ngIf="note" class="note">
      {{ note }}
    </p>
    <ng-content select="[sm-technical-button]"></ng-content>
    <div class="btn" *ngIf="links?.length">
      <a
      sitemule-button
      *ngFor="let link of links"
      [style.--button-color]="link.color"
      [ngStyle]="{'backgroundColor': link.backgroundColor, 'color': link.color}"
      [href]="link.href"
      [target]="link.target"
      [size]="link.size"
      [textSize]="link.textSize"
      [mobileTabletSize]="link.mobileTabletSize"
      [mobileTextSize]="link.mobileTextSize"
      [borderRadius]="link.borderRadius"
      >
        {{ link.label }}
      </a>
    </div>
  </div>
</div>
